module.exports = __webpack_public_path__ + "img/rca-logo-dark.4de4c791.svg";